package com.trevorwiebe.timesheet.mileage.domain.usecases

import com.trevorwiebe.timesheet.core.domain.TSResult
import com.trevorwiebe.timesheet.mileage.domain.MileageRepository

class DeleteMileageEntry(private val mileageRepository: MileageRepository) {
    suspend fun invoke(entryId: String): TSResult = mileageRepository.deleteMileageEntry(entryId)
}
